import useTranslation from "@babackapp/translations/use-translation";
import { Button } from "@babackapp/ui/components/button";
import { PropsWithChildren } from "react";
import HotKey from "@/components/hot-key";
import { Loader2 } from "lucide-react";

interface NavButtonProps extends PropsWithChildren {
  keyboardKey: string;
  isDisabled?: boolean;
  onClick?: () => void;
  isLoading?: boolean;
}

export default function NavButton({
  children,
  onClick,
  keyboardKey,
  isLoading,
}: NavButtonProps) {
  const t = useTranslation();

  return (
    <HotKey keyTrigger={keyboardKey} description={t("misc.navigation")}>
      <Button
        size="sm"
        disabled={isLoading}
        variant={"outline"}
        onClick={onClick}
      >
        {isLoading ? <Loader2 className="size-4 animate-spin" /> : children}
      </Button>
    </HotKey>
  );
}
